$bog_calculator_app $mol_page
	title @ \ Main
	plugins /
		<= Theme $mol_theme_auto
	tools /
		<= Lights $mol_lights_toggle
	body /
		<= Calculator $mol_view
			sub /
				<= Display $mol_string
					value? <=> display_value? \0
				<= Buttons $mol_view
					style *
						display \grid
						gridTemplateColumns \1fr 1fr 1fr 1fr
						gap \1px
					sub /
						<= Button_AC $mol_button_minor title \AC
						<= Button_plus_minus $mol_button_minor title \±
						<= Button_percent $mol_button_minor title \%
						<= Button_divide $mol_button_minor title \÷
						<= Button_7 $mol_button_minor title \7
						<= Button_8 $mol_button_minor title \8
						<= Button_9 $mol_button_minor title \9
						<= Button_multiply $mol_button_minor title \×
						<= Button_4 $mol_button_minor title \4
						<= Button_5 $mol_button_minor title \5
						<= Button_6 $mol_button_minor title \6
						<= Button_minus $mol_button_minor title \−
						<= Button_1 $mol_button_minor title \1
						<= Button_2 $mol_button_minor title \2
						<= Button_3 $mol_button_minor title \3
						<= Button_plus $mol_button_minor title \+
						<= Button_0 $mol_button_minor 
							title \0
						<= Button_dot $mol_button_minor title \.
						<= Button_equals $mol_button_minor title \=
